import { dataTableManifest } from './data/index.js';
import { CELLS, MISSION_IDS, RESOLUTION_PHASES, SEAT_IDS, TEAM_IDS } from './model/enums.js';
/**
 * Rule-content versioning (§10.1).
 *
 * Every rule table in this package belongs to a versioned content bundle. A game
 * records the version and hash it started with; the engine refuses to resolve a
 * turn against a different hash without explicit GM acknowledgement, so a
 * mid-exercise deploy can never silently change the rules under a running game.
 *
 * The *hash* is deliberately not computed here — hashing needs a crypto primitive
 * and `packages/rules` has no Node APIs (§4). The server hashes the canonical JSON
 * of `contentBundle()` at boot. This module's job is to produce that canonical,
 * stable-ordered object.
 *
 * **Bump this by hand when a modifier predicate changes.** Predicates are code, so
 * they are invisible to the hash (see `data/modifiers.ts`); a value change is
 * caught automatically, a predicate change is not.
 */
export const CONTENT_VERSION = '0.5.1';
/**
 * The canonical, serialisable content bundle.
 *
 * Key order is fixed and must stay fixed: the hash is order-sensitive. M1 adds
 * the §10.1 data tables the phase-3–6 resolvers read; M3 appends weapons,
 * escalation, environment, and the MW event table alongside them.
 */
export function contentBundle() {
    return {
        version: CONTENT_VERSION,
        vocabulary: {
            teams: TEAM_IDS,
            cells: CELLS,
            seats: SEAT_IDS,
            missions: MISSION_IDS,
            phases: RESOLUTION_PHASES,
        },
        tables: dataTableManifest(),
    };
}
//# sourceMappingURL=content.js.map